import React from 'react';
import { Modal, Spin, Tabs, Icon } from 'antd';
import ReactJson from 'react-json-view';
import InlineMessage from '../../atoms/InlineMessage';

const { TabPane } = Tabs;

const DebugModal = ({ cacheDuration, visible, onCancel, show, ui, api, loading }) => (
  <Modal width="80%" visible={visible} onCancel={onCancel} onOk={onCancel} title="Debug info">
    <Spin spinning={loading}>
      {cacheDuration !== null ? (
        <InlineMessage
          type={cacheDuration > 0 ? 'success' : 'error'}
          message={
            cacheDuration > 0
              ? 'You have the latest copy of the UI loaded in your browser.'
              : 'Your browser is out of sync with AWS. Try clearing your browser cache or loading a new incognito window.'
          }
        />
      ) : (
        <InlineMessage type="info" message="Could not determine UI cache status." />
      )}

      <Tabs size="large" defaultActiveKey="ui">
        <TabPane
          tab={
            <span>
              <Icon type="cloud" /> UI
            </span>
          }
          key="ui"
        >
          <ReactJson src={ui} />
        </TabPane>
        <TabPane
          tab={
            <span>
              <Icon type="code" /> API
            </span>
          }
          key="code"
        >
          <ReactJson src={api} />
        </TabPane>
      </Tabs>
    </Spin>
  </Modal>
);

export default DebugModal;
